export default __webpack_public_path__ + "static/media/no-skills.9e191a97.jpg";